import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  SFTypography,
  SFUseStyled,
  SFGridContainer,
  SFGridItem,
  SFStack,
  SFLink,
  HighlightText,
} from "@sf-core";

const { styled } = SFUseStyled();

const SFStackStyled = styled(SFStack)(() => ({
  lineHeight: "initial",
  height: "100%",
  paddingTop: 10,
  paddingBottom: 10,
}));

const SFTypographyStyled = styled(SFTypography)(({ noWrap, theme }) => ({
  whiteSpace: noWrap ? "noWrap" : "break-spaces",
  "& p": {
    margin: 0,
  },
  color: theme.palette.grey300.main,
}));

const SFLinkStyled = styled(SFLink)(({ theme }) => ({
  color: theme.palette.blue300.main,
  textDecoration: "none !important",
  paddingLeft: theme.spacing(0.2),
}));

const CustomNameCell = (props) => {
  const { t } = useTranslation();
  const [more, setMore] = useState(true);

  let filterModel = props.api.getFilterModel();

  const descriptionHasHtml = useMemo(() => {
    const htmlTagsRegex = /<\/?[a-z][\s\S]*>/i;
    return htmlTagsRegex.test(props.data.description);
  }, []);

  const htmlToPlainText = (htmlString) => {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlString;
    return tempElement.textContent || tempElement.innerText || "";
  };
  
  let description = props.data.description;
  if (descriptionHasHtml) {
    description = htmlToPlainText(props.data.description);
  }

  return (
    <SFStackStyled spacing={0.5} justifyContent="flex-start">
      <SFTypography variant="body1">
        {Object.prototype.hasOwnProperty.call(filterModel, "searchText")
          ? HighlightText(
            props.data.name,
            JSON.parse(filterModel.searchText.filter).value
          )
          : props.data.name}
      </SFTypography>
      {description && (
        <SFGridContainer spacing={0} alignItems="center">
          {more ? (
            <>
              <SFGridItem xs={11}>
                <SFTypographyStyled noWrap variant="body1">
                  {Object.prototype.hasOwnProperty.call(filterModel, "searchText"
                  )
                    ? HighlightText(
                      description,
                      JSON.parse(filterModel.searchText.filter).value
                    )
                    : description}
                </SFTypographyStyled>
              </SFGridItem>
              <SFGridItem xs="auto">
                <SFLinkStyled
                  onClick={() => setMore((curState) => !curState)}
                >
                  {t("profileScreen.drawer.showMore")}
                </SFLinkStyled>
              </SFGridItem>
            </>
          ) : (
            <>
              <SFGridItem xs={12}>
                <SFTypographyStyled variant="body1">
                  {Object.prototype.hasOwnProperty.call(filterModel, "searchText")
                    ? HighlightText(
                      description,
                      JSON.parse(filterModel.searchText.filter).value
                    )
                    : description}
                  <SFLinkStyled
                    onClick={() => setMore((curState) => !curState)}
                  >
                    {t("profileScreen.drawer.showLess")}
                  </SFLinkStyled>
                </SFTypographyStyled>
              </SFGridItem>
            </>
          )}
        </SFGridContainer>
      )}
    </SFStackStyled>
  );
};

export default CustomNameCell;
